<template>
  <div class="main-view">
    <el-radio-group
      v-model="table.params.type"
      class="tabsWrap"
      @change="handleTabs"
    >
      <el-radio-button :label="1">供应商</el-radio-button>
      <el-radio-button :label="2">采购员</el-radio-button>
    </el-radio-group>
    <div class="section shadow filter__wrap">
      <el-form ref="elFormDom" inline :model="table.params" :size="subUnitSize">
        <el-form-item label="账单月份" prop="date">
          <el-date-picker
            v-model="table.params.date"
            type="month"
            placeholder="选择月"
            format="yyyy 年 MM 月"
            value-format="yyyy-MM"
            @change="onSearch"
            :clearable="false"
          >
          </el-date-picker>
        </el-form-item>
        <template v-if="table.params.type == 1">
          <el-form-item label="供应商" prop="supplier_id">
            <el-select
              v-model="table.params.supplier_id"
              filterable
              id="bind_id"
              clearable
              placeholder="请输入"
              @focus="getSupplier"
              @change="onSearch"
            >
              <el-option
                v-for="item in supplierOpt"
                :label="item.name"
                :value="item.id"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="联系人" prop="contact">
            <el-input
              v-model.trim="table.params.contact"
              placeholder="请输入"
              clearable
              @keydown.enter.native="onSearch"
            ></el-input>
          </el-form-item>
          <el-form-item label="是否开票" prop="is_invoice">
            <el-select
              v-model="table.params.is_invoice"
              clearable
              placeholder="请选择"
              @change="onSearch"
            >
              <el-option label="是" :value="1"> </el-option>
              <el-option label="否" :value="2"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="结清状态" prop="settle_status">
            <el-select
              v-model="table.params.settle_status"
              clearable
              placeholder="请选择"
              @change="onSearch"
            >
              <el-option label="未结算" :value="1"> </el-option>
              <el-option label="部分结清" :value="2"> </el-option>
              <el-option label="已结清" :value="3"> </el-option>
            </el-select>
          </el-form-item>
        </template>
        <el-form-item
          label="采购员"
          prop="supplier_id"
          v-if="table.params.type == 2"
        >
          <el-select
            v-model="table.params.supplier_id"
            filterable
            id="supplier_id"
            clearable
            placeholder="请输入"
            @focus="getBuyerSel"
            @change="onSearch"
          >
            <el-option
              v-for="item in buyerArr"
              :label="item.name"
              :value="item.id"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="交货日期" prop="delivery_date">
          <el-date-picker
            v-model="table.params.delivery_date"
            type="date"
            placeholder="选择交货日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            @change="onSearch"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="采买方式" prop="buy_type" v-if="table.params.type == 1">
          <el-select v-model="table.params.buy_type" placeholder="请选择" clearable filterable style="width: 100%" @change="onSearch">
            <el-option
              label="现金采买"
              :value="1"
            ></el-option>
            <el-option
              label="非现金采买"
              :value="2"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="结算周期" prop="settle_day" v-if="table.params.type == 1">
          <el-select v-model="table.params.settle_day" placeholder="请选择" clearable filterable style="width: 100%" @change="onSearch">
            <el-option
              v-for="item in settleDayOpt"
              :label="item.name"
              :value="item.id"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSearch"
            >搜索</el-button
          >
          <el-button icon="el-icon-refresh-right" @click="reset"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
      <div class="btnAdd" style="display: flex; align-items: center">
        <!-- /admin/bill/export -->
        <el-button
          :size="subUnitSize"
          type="primary"
          plain
          @click="exportDataAll('/admin/bill/exportDetail')"
          icon="el-icon-download"
          >导出</el-button
        >
        <template v-if="table.params.type == 1">
          <span
            style="
              margin-left: 20px;
              color: #f56c6c;
              font-size: 14px;
              font-weight: bold;
            "
            >汇总:
          </span>
          <span
            style="
              margin-left: 20px;
              color: #f56c6c;
              font-size: 14px;
              font-weight: bold;
            "
            >账单金额: ￥{{ summary.bill_amount }}
          </span>
          <span
            style="
              margin-left: 20px;
              color: #f56c6c;
              font-size: 14px;
              font-weight: bold;
            "
            >已开票金额: ￥{{ summary.total_invoice_amount }}
          </span>
          <span
            style="
              margin-left: 20px;
              color: #f56c6c;
              font-size: 14px;
              font-weight: bold;
            "
            >税额: ￥{{ summary.total_tax }}
          </span>
          <span
            style="
              margin-left: 20px;
              color: #f56c6c;
              font-size: 14px;
              font-weight: bold;
            "
            >待开票金额: ￥{{ summary.total_invoice_await }}
          </span>
          <span
            style="
              margin-left: 20px;
              color: #f56c6c;
              font-size: 14px;
              font-weight: bold;
            "
            >付款金额: ￥{{ summary.total_yet_settle }}
          </span>
          <span
            style="
              margin-left: 20px;
              color: #f56c6c;
              font-size: 14px;
              font-weight: bold;
            "
            >待付款金额: ￥{{ summary.total_await_settle }}
          </span>
          <span
            style="
              margin-left: 20px;
              color: #f56c6c;
              font-size: 14px;
              font-weight: bold;
            "
            >折扣金额: ￥{{ summary.total_discount_amount }}
          </span>
        </template>
        <template v-else>
          <span
            style="
              margin-left: 20px;
              color: #f56c6c;
              font-size: 14px;
              font-weight: bold;
            "
            >采购金额汇总: {{ table.total_delivery_money }}元</span
          >
          <span
            style="
              margin-left: 20px;
              color: #f56c6c;
              font-size: 14px;
              font-weight: bold;
            "
            >垫付运费: {{ table.total_freight_amount }}元</span
          >
          <span
            style="
              margin-left: 20px;
              color: #f56c6c;
              font-size: 14px;
              font-weight: bold;
            "
            >抹零金额: {{ table.total_discount_amount }}元</span
          >
          <span
            style="
              margin-left: 20px;
              color: #f56c6c;
              font-size: 14px;
              font-weight: bold;
            "
            >账单金额: {{ table.bill_amount }}元</span
          >
        </template>
      </div>
    </div>

    <VTable
      has-pagionation
      :field="table.params.type == 1 ? field : field2"
      :loading="table.loading"
      :data="table.data"
      :page="table.params.page"
      :pageSize="table.params.count"
      :total="table.total"
      :tree-props="{ children: 'children', hasChildren: 'has_child' }"
      :hasPagionation="true"
      :default-expand-all="true"
      :showSelect="true"
      :showIndex="true"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
      @handleSelectionChange="handleSelectionChange"
    >
      <template v-slot:settle_status="{ row }">
        <span :class="{isGreen:row.settle_status != 3}">{{
          row.settle_status == 1
            ? "未结算"
            : row.settle_status == 2
            ? "部分结清"
            : row.settle_status == 3
            ? "已结清"
            : ""
        }}</span>
      </template>
      <template v-slot:yet_invoice_amount="{ row }">
        <div>{{row.yet_invoice_amount}}</div>
        <div v-if="Number(row.tax) > 0">(税:￥{{row.tax}})</div>
      </template>
      <template v-slot:is_invoice="{ row }">
        <span :class="{isGreen:row.is_invoice == 1}">{{ row.is_invoice == 1 ? "已开票" : "未开票" }}</span>
      </template>
      <template v-slot:action="{ row }">
        <div class="action-row">
          <el-button size="small" type="text" @click="showDetail(row)"
            >查看</el-button
          >
          <el-button
            size="small"
            class="margin-right6"
            type="text"
            @click="exportData(row)"
            >导出明细</el-button
          >
          <template v-if="table.params.type == 1">
            <el-button
              class="margin-right6"
              size="small"
              type="text"
              @click="showInvoice(row)"
              >发票信息</el-button
            >
            <el-badge :value="row.await_count ? row.await_count : ''">
              <el-button
                class="margin-right6"
                size="small"
                type="text"
                @click="showSettle(row)"
                >结算信息</el-button
              >
            </el-badge>
          </template>
        </div>
      </template>
    </VTable>
    <!-- <div style="position: absolute;bottom: 30px;left: 35px;">
      <span style="color:#f56c6c;font-size:14px;font-weight:bold;">采购金额汇总: {{table.total_delivery_money}}元</span>
    </div> -->
    <!-- 明细详情 -->
    <detail
      ref="detail"
      :sleDate="table.params"
      @refresh="getTable"
      @showSettleDialog="showSettleCleanPart"
      @showBatchSettleDialog="showSettleClean"
    ></detail>
    <!-- 发票信息 -->
    <el-dialog
      width="800px"
      center
      title="发票信息"
      :before-close="handleCloseDialogInvoice"
      :visible.sync="dialogInvoiceVisible"
    >
      <el-button type="primary" :size="subUnitSize" @click="addInvoice"
        >添加发票</el-button
      >
      <el-table
        class="margin-top-10"
        :data="invoiceTable.data"
        style="width: 100%"
        max-height="400"
        v-loading="invoiceTable.loading"
        :header-cell-style="{ background: '#f5f5f5' }"
        border
      >
        <el-table-column prop="date" label="开票日期"> </el-table-column>
        <el-table-column prop="amount" label="发票金额">
          <template slot-scope="scope">
            <span>￥{{ scope.row.amount }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="tax" label="税额">
          <template slot-scope="scope">
            <span>￥{{ scope.row.tax }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="image" label="发票" show-overflow-tooltip>
          <!-- {{scope.row.image?scope.row.image.substr(scope.row.image.lastIndexOf("/")+1):''}} -->
          <template slot-scope="scope">
            <div style="color: #409EFF;cursor: pointer;"  v-for="(item,index) in scope.row.image" :key="index" size="small" type="text" @click="viewInvoive2(item.file)"
              >{{item.name}}</div
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="create_time"
          label="创建时间"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column prop="create_name" label="创建人" width="80"> </el-table-column>
        <el-table-column prop="action" label="操作" width="60">
          <template slot-scope="scope">
            <el-button size="small" type="text" @click="editInvoive(scope.row)"
              >修改</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-dialog
        width="300px"
        :title="addInvoiceTitle"
        :visible.sync="addInvoiceVisible"
        center
        :before-close="handleCloseaddInvoice"
        append-to-body
      >
        <el-form
          :model="addInvoiceForm"
          :rules="addInvoiceForm.rules"
          ref="saveInvoiceDom"
          label-width="auto"
          label-position="left"
        >
          <el-form-item label="开票日期" prop="date">
            <el-date-picker
              v-model="addInvoiceForm.date"
              :size="subUnitSize"
              type="date"
              placeholder="选择日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              clearable
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="发票金额" prop="amount">
            <el-input
              v-model="addInvoiceForm.amount"
              :size="subUnitSize"
              v-money
              clearable
              placeholder="请输入"
              style="width: 100%"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="税额" prop="tax">
            <el-input
              v-model="addInvoiceForm.tax"
              :size="subUnitSize"
              v-money
              clearable
              placeholder="请输入"
              style="width: 100%"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="发票凭证" prop="image">
            <el-upload
              class="upload-demo"
              action="/api/common/qiniu/uploadFile"
              :limit="3"
              :headers="{ token: token }"
              :on-success="handleAvatarSuccess"
              :on-remove="handleRemove"
              ref='uploadDom'
              :file-list="addInvoiceForm.fileList"
              accept="image/jpeg, image/png, image/gif, .pdf, .xlsx, .xls "
            >
              <el-button :size="subUnitSize" type="primary" plain
                >请上传</el-button
              >
            </el-upload>
          </el-form-item>
        </el-form>
        <template #footer>
          <el-row type="flex" justify="center">
            <el-button :size="subUnitSize" type="primary" @click="saveInvoice"
              >确定</el-button
            >
          </el-row>
        </template>
      </el-dialog>
    </el-dialog>
    <!-- 结算信息 -->
    <el-dialog
      width="800px"
      center
      title="结算信息"
      :before-close="closeSettleDialog"
      :visible.sync="dialogSettleVisible"
    >
      <el-table
        class="margin-top-10"
        v-loading="settleTable.loading"
        :data="settleTable.data"
        max-height="400"
        style="width: 100%"
        :header-cell-style="{ background: '#f5f5f5' }"
        border
      >
        <el-table-column prop="days" label="账单天数">
          <template slot-scope="scope">
            <el-button
              size="small"
              type="text"
              @click="showSettleDetails(scope.row)"
              >{{ scope.row.days }}天</el-button
            >
          </template>
        </el-table-column>
        <el-table-column prop="amount" label="结算金额">
          <template slot-scope="scope">
            <span>￥{{ scope.row.amount }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="image" label="支付凭证">
          <template slot-scope="scope">
            <el-button size="small" type="text" v-if="scope.row.image" @click="viewInvoive(scope.row)"
              >打款凭证</el-button
            >
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间"> </el-table-column>
        <el-table-column prop="create_name" label="创建人"> </el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <!--状态 1:带审核 2:已通过 3:已驳回 -->
            <span>{{
              scope.row.status == 1
                ? "审核中"
                : scope.row.status == 2
                ? "已确认"
                : scope.row.status == 3
                ? "已驳回"
                : ""
            }}</span>
          </template>
        </el-table-column>
        <el-table-column  label="操作" v-if="role_id">
          <template slot-scope="scope">
            <!-- <el-button
              size="small"
              type="text"
              @click="approve(scope.row.id, 1)"
              v-if="scope.row.status == 1"
              >通过</el-button
            >
            <el-button
              size="small"
              type="text"
              @click="approve(scope.row.id, 2)"
              v-if="scope.row.status == 1"
              >驳回</el-button
            > -->
            <span v-if="scope.row.status == 1">去付款流程中去审核</span>
            <el-button size="small" @click="editImage(scope.row)" type="text" v-if="scope.row.status == 2"
              >修改凭证</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-dialog
        :title="'账单天数:' + settleDetailTitle +'天'"
        :visible.sync="settleDetailVisible"
        center
        append-to-body
      >
        <el-table
          v-loading="settleDetailsTable.loading"
          class="margin-top-10"
          :data="settleDetailsTable.data"
          style="width: 100%"
          :header-cell-style="{ background: '#f5f5f5' }"
          border
        >
          <el-table-column prop="delivery_date" label="交货日期">
          </el-table-column>
          <el-table-column prop="purchase_count" label="收货采购单/笔">
          </el-table-column>
          <el-table-column prop="total_order_num" label="下单数量">
          </el-table-column>
          <el-table-column prop="total_delivery_num" label="收货数量">
          </el-table-column>
          <el-table-column prop="total_delivery_money" label="收货金额">
          </el-table-column>
          <el-table-column prop="yet_amount" label="已通过金额">
          </el-table-column>
          <el-table-column prop="goods_name" label="未结金额">
            <template slot-scope="scope">
              <span>{{
                (Number(scope.row.total_delivery_money)*1000 - Number(scope.row.yet_amount)*1000)/1000
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="amount" label="本次结算"> </el-table-column>
          <el-table-column prop="is_settle" label="操作类型">
            <template slot-scope="scope">
              <span>{{
                scope.row.is_settle == 1
                  ? "结清"
                  : scope.row.is_settle == 0
                  ? "部分结清"
                  : ""
              }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
      <!-- 修改凭证 -->
      <el-dialog
        title="修改凭证"
        :visible.sync="editImageVisible"
        center
        append-to-body>
        <el-form
          :model="editImageForm"
          :rules="editImageForm.rules"
          ref="editImageDom"
          label-width="auto"
          label-position="left"
        >
          <el-form-item label="打款凭证" prop="image">
            <el-upload
              class="upload-demo"
              action="/api/common/qiniu/uploadFile"
              :limit="1"
              :headers="{ token: token }"
              :on-success="handleEditImageSuccess"
              :on-remove="handleEditImageRemove"
              :file-list="editImageForm.fileList"
              accept="image/jpeg, image/png, image/gif, .pdf, .xlsx, .xls "
            >
              <el-button :size="subUnitSize" type="primary" plain
                >请上传</el-button
              >
            </el-upload>
          </el-form-item>
        </el-form>
        <template #footer>
          <el-row type="flex" justify="center">
            <el-button :size="subUnitSize" type="primary" @click="saveEditImage"
              >确定</el-button
            >
          </el-row>
        </template>
    </el-dialog>
    </el-dialog>

    <settleDialogPart
      ref="settleDialogPart"
      @settlePartDone="settlePartDone"
    ></settleDialogPart>
  </div>
</template>

<script>
import Detail from "./components/Detail.vue";
import settleDialog from "./components/settleDialog";
import settleDialogPart from "./components/settleDialogPart.vue";
import VTable from "@/components/VTable";
import { mixinTable } from "@/mixins/table.js";
import { mapGetters } from "vuex";
import { getStorage } from "@/storage/index.js";
export default {
  name: "SupplierIndex",
  components: {
    Detail,
    VTable,
    settleDialog,
    settleDialogPart,
  },
  mixins: [mixinTable],
  computed: {
    ...mapGetters(["areaArr"]),
    role_id() {
      //role_id =  12  财务才有权限审批结算
      return getStorage("role_id") == 12;
    },
  },
  data() {
    return {
      subUnitSize: this.$store.state.subUnitSize, // 获取组件 size属性
      field: [
        { name: "supplier_name", label: "供应商名称", hidden: false },
        { name: "contact", label: "联系人", hidden: false },
        { name: "total_delivery_count", label: "采购单(笔)", hidden: false },
        { name: "total_delivery_money", label: "采购金额(元)", hidden: false },
        { name: "freight_amount", label: "垫付运费(元)", hidden: false },
        { name: "total_discount_amount", label: "折扣金额(元)", hidden: false },
        { name: "bill_amount", label: "账单金额(元)", hidden: false },
        { name: "yet_invoice_amount", label: "已开票金额(元)", hidden: false,width:100 },
        { name: "await_invoice_amount", label: "待开票金额(元)", hidden: false },
        { name: "yet_settle_amount", label: "结算金额(元)", hidden: false },
        { name: "await_settle_amount", label: "待结金额(元)", hidden: false },
        { name: "settle_status", label: "结清状态", hidden: false },
        { name: "is_invoice", label: "是否开票", hidden: false },
        { name: "buy_type", label: "采买方式", hidden: false },
        { name: "settle_day", label: "结算周期", hidden: false },
        { name: "change_time", label: "最新收货时间", hidden: false },
        {
          name: "action",
          label: "操作",
          width: "240",
          fixed: "right",
          hidden: false,
        },
      ],
      field2: [
        { name: "supplier_name", label: "采购员名称", hidden: false },
        { name: "total_delivery_count", label: "采购单(笔)", hidden: false },
        { name: "base_delivery_money", label: "采购金额(元)", hidden: false },
        { name: "freight_amount", label: "垫付运费(元)", hidden: false },
        { name: "total_discount_amount", label: "抹零金额(元)", hidden: false },
        { name: "bill_amount", label: "账单金额(元)", hidden: false },
        { name: "change_time", label: "最新收货时间", hidden: false },
        {
          name: "action",
          label: "操作",
          width: "120",
          fixed: "right",
          hidden: false,
        },
      ],
      loading: false,
      table: {
        loading: false,
        params: {
          type: 1, //类型 1:供应商 2:采购员
          delivery_date: "", //交货日期
          date: "", // 当前月
          supplier_id: "",
          contact: "",
          is_invoice: "",
          settle_status: "",
          settle_day:'',
          buy_type :'',
          page: 1,
          count: 10,
        },
        data: [],
        total: 0,
        total_delivery_money: 0, //采购金额汇总
        bill_amount:0,
        total_freight_amount:0,
        total_discount_amount:0,
      },
      summary: {},
      //供应商id
      currentSupplier_Id: "",
      //发票信息
      invoiceTable: {
        loading: false,
        data: [],
      },
      supplierOpt: [], // 供应商
      purchaseOpt: [], // 采购员
      buyerArr: [], // 采购员
      //添加发票表单数据
      addInvoiceTitle: "",
      dialogInvoiceVisible: false,
      addInvoiceVisible: false,
      addInvoiceForm: {
        date: "",
        amount: "",
        image: "",
        id: "",
        file: "",
        fileList: [],
        tax:'',
        rules: {
          date: [{ required: true, message: "请选择日期", trigger: "change" }],
          amount: [{ required: true, message: "请输入金额", trigger: "blur" }],
          image: [{ required: true, message: "请上传", trigger: "blur" }],
          tax: [{ required: true, message: "必填", trigger: "blur" }],
        },
      },
      //结算信息
      dialogSettleVisible: false,
      settleTable: {
        loading: false,
        data: [],
      },
      //结算信息弹窗详情
      settleDetailVisible: false,
      settleDetailTitle: "",
      settleDetailsTable: {
        loading: false,
        data: [],
      },
      //编辑结算信息的凭证
      editImageVisible:false,
      editImageId:'', // 编辑凭证ID
      editImageForm:{
        rules:{},
        fileList:[],
        image:'',
      },
      settleDayOpt: [
          {name: '当天', id: 1},
          {name: '7天', id: 2},
          {name: '10天', id: 3},
          {name: '15天', id: 4},
          {name: '30天', id: 5},
          {name: '45天', id: 6},
      ], // 结算周期
    };
  },
  created() {
    this.table.params.date = this.$moment(new Date()).format("YYYY-MM"); // 默认当前月份
    this.getTable();
  },
  methods: {
    getTable() {
      let _params = { ...this.table.params };
      this.table.loading = true;
      this.$http.get("/admin/bill/list", { params: _params }).then((res) => {
        if (res.code === 1) {
          this.table.loading = false;
          this.table.data = res.data.list;
          this.table.total = res.data.total;
          this.table.total_delivery_money = res.data.total_delivery_money; // 采购金额汇总
          this.table.total_freight_amount = res.data.total_freight_amount; 
          this.table.total_discount_amount = res.data.total_discount_amount; 
          this.table.bill_amount = res.data.bill_amount; 
          this.summary = res.data;
        }
      });
    },
    // 供应商 (is_all:1:是否显示隐藏供应商)
    getSupplier() {
      this.$http
        .get("/admin/supplier/list", {
          params: { page: 1, count: 10000, is_all: 1 },
        })
        .then((res) => {
          if (res.code == 1) {
            this.supplierOpt = res.data.list;
          }
        });
    },
    // 采购员
    getPurchase() {
      this.$http
        .get("/admin/purchase/list", { params: { page: 1, count: 10000 } })
        .then((res) => {
          if (res.code == 1) {
            this.purchaseOpt = res.data.list;
          }
        });
    },
    // 下单明细
    showDetail(row) {
      this.currentSupplier_Id = row.bind_id; // 供应商ID
      let dom = this.$refs.detail;
      dom.toggle(true);
      let obj = {
        ...row,
        month: this.table.params.date, // 下单月份
        delivery_date: this.table.params.delivery_date,
      };
      dom.getDetail(obj);
      dom = null;
    },
    settlePartDone() {
      let dom = this.$refs.detail;
      dom.getTable();
    },
    // 导出供应商账单列表
    exportDataAll(url) {
      // let obj = { ...this.table.params }
      // 没有勾选数据默认是全部导出，勾选了数据就是批量导出
      if (this.multipleSelection.length > 0) {
        let _ids = this.multipleSelection
          .map((v) => {
            return v.bind_id;
          })
          .join(",");
        let data = {
          url: url,
          obj: {
            month: this.table.params.date,
            supplier_id: _ids,
            type: this.table.params.type,
          },
        };
        this.exportFun(data);
      } else {
        this.$confirm("确定导出列表全部数据吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        })
          .then(() => {
            let data = {
              url: url,
              obj: {
                month: this.table.params.date,
                is_all: 1, // 是否全部导出
                type: this.table.params.type,
              },
            };
            this.exportFun(data);
          })
          .catch(() => {});
      }
    },
    exportFun(data) {
      let obj = data.obj;
      let url = data.url;
      let str = "";
      Object.keys(obj).forEach((item) => {
        str += `&${item}=${obj[item]}`;
      });
      console.log(
        `${process.env.VUE_APP_BASE_API}${url}?token=${this.token}${str}`
      );
      window.open(
        `${process.env.VUE_APP_BASE_API}${url}?token=${this.token}${str}`
      );
    },
    // 供应商账单导出明细细
    exportData(row) {
      let url = "/admin/bill/exportDetail";
      let obj = {
        month: this.table.params.date,
        supplier_id: row.bind_id,
        type: this.table.params.type,
        delivery_date:this.table.params.delivery_date,
      };
      let str = "";
      Object.keys(obj).forEach((item) => {
        str += `&${item}=${obj[item]}`;
      });
      console.log(
        `${process.env.VUE_APP_BASE_API}${url}?token=${this.token}${str}`
      );
      window.open(
        `${process.env.VUE_APP_BASE_API}${url}?token=${this.token}${str}`
      );
    },
    showInvoice(row) {
      this.dialogInvoiceVisible = true;
      this.currentSupplier_Id = row.bind_id;
      this.getInvoiceDetail();
    },
    getInvoiceDetail() {
      let params = {
        page: 1,
        count: 1000,
        date: this.table.params.date,
        supplier_id: this.currentSupplier_Id,
      };
      this.invoiceTable.loading = true;
      this.$http
        .get("admin/bill/invoiceInfo", { params: params })
        .then((res) => {
          if (res.code == 1) {
            this.invoiceTable.data = res.data.list;
          }
        })
        .finally(() => {
          this.invoiceTable.loading = false;
        });
    },
    showSettle(row) {
      this.dialogSettleVisible = true;
      this.currentSupplier_Id = row.bind_id;
      this.getSettleDetail();
    },
    getSettleDetail() {
      let params = {
        page: 1,
        count: 1000,
        date: this.table.params.date,
        supplier_id: this.currentSupplier_Id,
      };
      this.settleTable.loading = true;
      this.$http
        .get("admin/bill/settleInfo", { params: params })
        .then((res) => {
          if (res.code == 1) {
            this.settleTable.data = res.data.list;
          }
        })
        .finally(() => {
          this.settleTable.loading = false;
        });
    },
    addInvoice() {
      this.addInvoiceTitle = "新增发票";
      this.addInvoiceVisible = true;
    },
    // 图片上传成功
    handleAvatarSuccess(event,file,fileList) {
      if (event.code == 1) {
        this.$refs.saveInvoiceDom.clearValidate('image');
        this.addInvoiceForm.fileList = fileList.map(item =>{
          return {
            url:item.url || item.response.data.all_path_url, 
            name:item.name
          }
        });
      } else {
        this.$message({
          type: "error",
          message: event.msg,
        });
      }
    },
    handleEditImageSuccess(event) {
      if (event.code == 1) {
        this.editImageForm.image = event.data.all_path_url;
      } else {
        this.$message({
          type: "error",
          message: event.msg,
        });
      }
    },
    // 移除图片
    handleRemove(file, fileList) {
      this.addInvoiceForm.fileList = fileList.map(item =>{
          return {
            url:item.url || item.response.data.all_path_url, 
            name:item.name
          }
      });
    },
    handleEditImageRemove(file, fileList) {
      this.editImageForm.image = "";
      this.editImageForm.fileList = [];
    },
    editInvoive(row) {
      this.addInvoiceTitle = "编辑发票";
      let y = row.date.toString().substr(0, 4);
      let m = row.date.toString().substr(4, 2);
      let d = row.date.toString().substr(6, 2);
      this.addInvoiceForm.date = y + "-" + m + "-" + d;
      this.addInvoiceForm.amount = row.amount;
      // let fapiaoObj = { name: "发票", url: row.image };
      let fileList_ = row.image.map(item =>{
        return {
          name: item.name,
          url: item.file,
        };
      });
      this.addInvoiceForm.fileList = fileList_;
      this.addInvoiceForm.image = fileList_.map(item => item.url).join(',');
      this.addInvoiceVisible = true;
    },
    viewInvoive(row) {
      window.open(row.image, "_blank");
    },
    viewInvoive2(row) {
      window.open(row, "_blank");
    },
    showSettleDetails(row) {
      this.settleDetailVisible = true;
      this.settleDetailTitle = row.days;
      this.getsettleDayDetail(row.id);
    },
    getsettleDayDetail(id) {
      let params = {
        id: id,
      };
      this.settleDetailsTable.loading = true;
      this.$http
        .get("admin/bill/settleBill", { params: params })
        .then((res) => {
          if (res.code == 1) {
            this.settleDetailsTable.data = res.data.list;
          }
        })
        .finally(() => {
          this.settleDetailsTable.loading = false;
        });
    },
    showSettleClean() {
      let dom = this.$refs.settleDialog;
      dom.toggle(true);
      //塞入多选的数据
      dom.getDetail();
    },
    showSettleCleanPart(row, isAll) {
      let dom = this.$refs.settleDialogPart;
      dom.toggle(true);
      dom.getDetail(row, isAll);
    },
    saveInvoice() {
      this.addInvoiceForm.image = this.$refs.uploadDom.uploadFiles.map(item =>item.url|| item.response.data.all_path_url).join(',');
      this.$refs.saveInvoiceDom.validate((valid) => {
        if (valid) {
          let params = {
            date: this.addInvoiceForm.date,
            amount: this.addInvoiceForm.amount,
            tax: this.addInvoiceForm.tax,
            image: this.addInvoiceForm.fileList.map(item =>{
              return {
                file:item.url,
                name:item.name,
              }
            }),
            supplier_id: this.currentSupplier_Id,
            bill_month:this.table.params.date
          };
          this.$http.post("/admin/bill/invoice", params).then((res) => {
            if (res.code == 1) {
              this.$message({
                type: "success",
                message: '操作成功',
              });
              this.addInvoiceVisible = false;
              this.handleCloseaddInvoice();
              this.getInvoiceDetail();
            } else {
              this.$message({
                type: "error",
                message: '操作成功',
              });
            }
          });
        }
      });
    },
    async saveEditImage() {
      let params = {
        id: this.editImageId,
        image: this.editImageForm.image
      };
      const res = await this.$http.post('/admin/bill/updateVoucher',params)
      if(res.code==1){
        this.editImageVisible = false;
        this.getSettleDetail();
      }
    },
    approve(id, type) {
      this.$confirm(
        `确定${type == 1 ? "通过" : "驳回"}该条结算信息？`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        let params = {
          id: id,
          status: type,
        };
        this.$http.post("admin/bill/settleOperation", params).then((res) => {
          if (res.code == 1) {
            this.$message({
              type: "success",
              message: '操作成功',
            });
            this.getSettleDetail();
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        });
      });
    },
    editImage(row) {
      this.editImageId = row.id;
      let  fapiaoObj = { name: "打款凭证", url: row.image };
      this.editImageForm.fileList = [fapiaoObj];
      this.editImageForm.image = row.image;
      this.editImageVisible = true;
    },
    handleCloseaddInvoice() {
      this.addInvoiceForm.date = '';
      this.addInvoiceForm.amount = '';
      this.addInvoiceForm.fileList = [];
      this.addInvoiceForm.tax = '';
      this.addInvoiceForm.image = '';
      this.addInvoiceVisible = false;
    },
    closeSettleDialog() {
      this.getTable();
      this.dialogSettleVisible = false;
    },
    handleCloseDialogInvoice() {
      this.getTable();
      this.dialogInvoiceVisible = false;
    }
  },
};
</script>
<style scoped lang="scss">
::v-deep .el-badge__content.is-fixed {
  right: 18px !important;
}
.action-row {
  margin-top: 10px;
  display: flex;
}
.margin-right6 {
  margin-right: 6px;
}
.margin-top-10 {
  margin-top: 10px;
}
.isGreen{
  color: #F59A23;
}
</style>